import { FormattedMessage } from 'react-intl';
import styled, { css } from 'styled-components';

import { mediaConfined, mediaTopBarVisible } from '@xing-com/layout-tokens';
import {
  xdlColorText,
  xdlColorTextOnLight,
  spaceXL,
  spaceXXL,
  space3XL,
  spaceL,
} from '@xing-com/tokens';
import { Hero as BaseHero } from '@xing-com/typography';

type Props = {
  isSearchAndShuffle?: boolean;
};

const Hero = styled(BaseHero)<{ $isSearchAndShuffle?: boolean }>`
  padding-top: ${spaceXXL};
  text-align: center;
  color: ${xdlColorTextOnLight};
  margin: 0 20px ${spaceXL} 20px;
  text-wrap: balance;

  @media ${mediaConfined} {
    padding-top: ${spaceL};
    margin-bottom: ${spaceXL};
  }

  ${({ $isSearchAndShuffle }) =>
    $isSearchAndShuffle &&
    css`
      color: ${xdlColorText};

      @media ${mediaTopBarVisible} {
        display: none;
      }

      @media ${mediaConfined} {
        padding-top: ${space3XL};
      }
    `};
`;

export const Title: React.FC<Props> = ({ isSearchAndShuffle }) => {
  return (
    <Hero
      size="small"
      sizeConfined="medium"
      $isSearchAndShuffle={isSearchAndShuffle}
    >
      <FormattedMessage id="JOBS_SEARCH_AI_HEADLINE" />
    </Hero>
  );
};
